import React, { useEffect, useMemo, useState } from "react";
import { Col, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { BsFileEarmarkExcelFill, BsFileEarmarkPdfFill } from "react-icons/bs";
import ConfirmAlert from "../../components/ConfirmAlert";
import { Helmet } from "react-helmet";
import {
  approveRejectOutletById,
  deleteOutletById,
  getAllOutlet,
  downloadApprovedFuelStationExcel,
  downloadApprovedFuelStationPdf,
} from "../../services/contractorApi";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { createColumnHelper } from "@tanstack/react-table";
import ActionButtons from "../../components/DataTable/ActionButtons";
import CustomTable from "../../components/DataTable/CustomTable";
import TableHeader from "../../components/DataTable/TableHeader";
import { UserPlus } from "lucide-react";
import { selectUser } from "../../features/auth/authSlice";
import { useSelector } from "react-redux";
import { serialNumber } from "../../utils/helper";
import { canAct } from "../../utils/menuNodes";
import { UserDetail } from "../../components/ItemDetail";
import {getOutletDropdownData} from "../../services/contractorApi";
import {
  getAdminEnergyCompanyassignZone,
  getRoOnZoneId,
  getSalesOnRoId,
  getAdminDistrictOnSaId,
} from "../../services/authapi";
import { getOutletByDistrictId   } from "../../services/adminApi";


import DynamicFilter from "../../components/DynamicFilter/DynamicFilter";
const ApprovedOutlet = ({ checkPermission }) => {
  const columnHelper = createColumnHelper();
  const [rows, setRows] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [search, setSearch] = useState("");
  const [searchParams] = useSearchParams();
  const pageNo = searchParams.get("pageNo") || 1;
  const pageSize = searchParams.get("pageSize") || 10;
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useSelector(selectUser);
  const [showDelete, setShowDelete] = useState(false);
  const [showReject, setShowReject] = useState(false);
  const [outletId, setOutletId] = useState("");
  const [filters, setFilters] = useState({});

  const [dropdownOptions, setDropdownOptions] = useState({
    energy_company_id: [],
    outlet_id: [],
    customer_code: [],
    regional_office_id: [],
    outlet_name: [],
    zone_id: [],
    sales_area_id: [],
    district_id: [],
    category: [],
    location: [],
  });
  const navigate = useNavigate();
  const { t } = useTranslation();

  const fetchOutletAllData = async (customFilter = {}) => {
    const status = 2;
    const payload = {
      search,
      pageSize,
      pageNo,
      status,
      ...filters,
      ...customFilter,
    };

    const res = await getAllOutlet(payload);

    setIsLoading(true);
    if (res.status) {
      setRows(res.data);
      setTotalData(res?.pageDetails?.total);
      console.log(res.data);
    } else {
      setRows([]);
      setTotalData(0);
    }
    setIsLoading(false);
  };
  const fetchAllZone = async (id) => {
    const res = await getAdminEnergyCompanyassignZone(id);
    if (res.status) {
      setDropdownOptions((prev) => ({
        ...prev,
        zone: res?.data?.map((itm) => ({
          value: itm.zone_id,
          label: itm.zone_name,
        })),
      }));
    } else {
      setDropdownOptions((prev) => ({
        ...prev,
        zone: [],
      }));
      toast.error(res.message);
    }
  };

  // All Regional Office
  const fetchAllRO = async (id) => {
    const res = await getRoOnZoneId(id);
    if (res.status) {
      setDropdownOptions((prev) => ({
        ...prev,
        ro_name: res?.data?.map((itm) => ({
          value: itm.ro_id,
          label: itm.regional_office_name,
        })),
      }));
    } else {
      setDropdownOptions((prev) => ({
        ...prev,
        ro_name: [],
      }));
    }
  };

  // All Sales Area And OrderBy
  const fetchAllSalesAreaAndOrderBy = async (id) => {
    const res = await getSalesOnRoId(id);
    // const res2 = await getOfficersListOnRo(id);
    if (res.status) {
      const rData = res?.data?.map((itm) => {
        return {
          value: itm.id,
          label: itm.sales_area_name,
        };
      });
      setDropdownOptions((prev) => ({
        ...prev,
        sales_area_id: rData,
      }));
    } else {
      setDropdownOptions((prev) => ({
        ...prev,
        sales_area_id: [],
      }));
      toast.error("Sales Area Not Found");
    }
  };

  // All District
  const fetchAllDistrict = async (id) => {
    const res = await getAdminDistrictOnSaId(id);
    if (res.status) {
  const rData = res?.data?.map((itm) => {
    return {
      value: itm.district_id,
      label: itm.district_name,
    };
  });
  setDropdownOptions((prev) => ({
    ...prev,
    district: rData,
  }));
    } else {
      setDropdownOptions((prev) => ({
        ...prev,
        district: [],
      }));
      toast.error("District Not Found");
    }
  };

  // All Outlet
  // const fetchAllOutlet = async (id) => {
  //   const res = await getOutletByDistrictId(id);
  //   if (res.status) {
  //     dropdownOptions((prev) => ({
  //       ...prev,
  //       outlet_id: res.data.map((itm) => ({
  //         value: itm.id,
  //         label: itm.outlet_name,
  //       })),
  //     }));
  //   } else {
  //     setDropdownOptions((prev) => ({
  //       ...prev,
  //       outlet_id: [],
  //     }));
  //     toast.error("Outlet Not Found");
  //   }
  // };

  // All Outlet By District Id
  const fetchAllOutletByDistrictId = async (id) => {
    const res = await getOutletByDistrictId(id);
    if (res.status) {
      // Create a Set of existing row IDs for faster lookup
      const existingRowIds = new Set(rows.map(row => row.id));
      
      // Filter and map the API response
      const outletOptions = res.data
        .filter(itm => existingRowIds.has(itm.id)) // Only include outlets that exist in rows
        .map(itm => ({
          value: itm.id,
          label: itm.outlet_name,
        }));
  
      setDropdownOptions(prev => ({
        ...prev,
        outlet_name: outletOptions,
        outlet_id: outletOptions,
      }));
    } else {
      setDropdownOptions(prev => ({
        ...prev,
        outlet_name: [],
        outlet_id: [],
      }));
      toast.error("Outlet Not Found");
    }
  };
  const getDropdowndata = async () => {
    const payload = {
      status: 2,
    };

    const dropdownres = await getOutletDropdownData(payload);

    if (dropdownres.status) {
      const data = dropdownres.data;

      setDropdownOptions({
        energy_company_name:
          data?.energy_company_name?.map((item) => ({
            value: item.energy_company_id,
            label: item.energy_company_name,
          })) || [],
        outlet_id:
          data?.outlets?.map((item) => ({
            value: item.outlet_unique_id,
            label: item.outlet_unique_id,
          })) || [],
        customer_code:
          data?.customer_code?.map((item) => ({
            value: item.customer_code,
            label: item.customer_code,
          })) || [],
        ro_name:
          data?.regional_office?.map((item) => ({
            value: item.regional_office_id,
            label: item.regional_office_name,
          })) || [],
        outlet_name:
          data?.outlets?.map((item) => ({
            value: item.outlet_name,
            label: item.outlet_name,
          })) || [],
        zone:
          data?.zone_name?.map((item) => ({
            value: item.zone_id,
            label: item.zone_name,
          })) || [],
        sales_area_id:
          data?.sales_area?.map((item) => ({
            value: item.sales_area_id,
            label: item.sales_area_name,
          })) || [],
        district:
          data?.district?.map((item) => ({
            value: item.district_id,
            label: item.district_name,
          })) || [],
        category:
          data?.category?.map((item) => ({
            value: item.outlet_category,
            label: item.outlet_category,
          })) || [],
        location:
          data?.location?.map((item) => ({
            value: item.location,
            label: item.location,
          })) || [],
      });
    }
  };

  const handleDelete = async () => {
    const res = await deleteOutletById(outletId);
    if (res.status) {
      toast.success(res.message);
      setRows((prev) => prev.filter((data) => data.id != outletId));
    } else {
      toast.error(res.message);
    }
    setOutletId("");
    setShowDelete(false);
  };

  const handleApproveReject = async () => {
    const status = "3";
    const res = await approveRejectOutletById(status, outletId);
    if (res.status) {
      toast.success(res.message);
      setRows((prev) => prev.filter((itm) => itm.id !== outletId));
      fetchOutletAllData();
    } else {
      toast.error(res.message);
    }
    setOutletId("");
    setShowReject(false);
  };

  useEffect(() => {
    fetchOutletAllData();
  }, [search, pageNo, pageSize]);
  useEffect(() => {
    if (rows.length > 0 && dropdownOptions?.ro_name?.length === 0 || dropdownOptions.ro_name === undefined) {
      getDropdowndata();
    }
  },  [rows] );
  // useEffect(() => {
  //   if (dropdownOptions.zone_id && dropdownOptions.zone_id.length > 0) {
  //     fetchAllZone();
  //   }
  // }, [JSON.stringify(dropdownOptions.zone_id)]);



  const columns = useMemo(
    () => [
      columnHelper.accessor("sr_no", {
        header: t("Sr No."),
        cell: (info) => {
          const serialNumbers = serialNumber(pageNo, pageSize);
          return serialNumbers[info.row.index];
        },
      }),
      columnHelper.accessor("outlet_unique_id", {
        header: "outlet id",
      }),
      columnHelper.accessor("outlet_name", {
        header: "outlet ",
      }),
      columnHelper.accessor("energy_company_name", {
        header: "energy company ",
      }),
      columnHelper.accessor("zone_name", {
        header: "zone ",
      }),
      columnHelper.accessor("regional_office_name", {
        header: "regional office ",
      }),
      columnHelper.accessor("sales_area_name", {
        header: "sales area ",
      }),
      columnHelper.accessor("district_name", {
        header: "district ",
      }),

      columnHelper.accessor("outlet_category", {
        header: "outlet category",
      }),
      columnHelper.accessor("customer_code", {
        header: "Customer Code ",
      }),
      columnHelper.accessor("location", {
        header: "Location ",
      }),
      // columnHelper.accessor("created_by", {
      //   header: t("Created By"),
      //   cell: (info) => (
      //     <UserDetail
      //       img={info.row.original?.created_by?.image}
      //       name={info.row.original?.created_by?.name}
      //       id={info.row.original?.created_by?.id}
      //       unique_id={info.row.original?.created_by?.employee_id}
      //       login_id={user.id}
      //     />
      //   ),
      // }),
      columnHelper.accessor("action", {
        header: "Action",
        cell: (info) => (
          <ActionButtons
            actions={{
              view: {
                show: checkPermission?.view,
                action: () =>
                  navigate(`/outlet/create/${info.row.original.id}?type=view`),
              },
              edit: {
                show: checkPermission?.update,
                action: () =>
                  navigate(`/outlet/create/${info.row.original.id}`),
              },
              delete: {
                show: checkPermission?.delete,
                action: () => {
                  setOutletId(info.row.original.id);
                  setShowDelete(true);
                },
              },
              reject: {
                show: canAct(checkPermission, "reject"),
                action: () => {
                  setOutletId(info.row.original.id);
                  setShowReject(true);
                },
              },
            }}
          />
        ),
      }),
    ],
    [checkPermission, t, rows.length, pageNo, pageSize]
  );
  const fields = [
    {
      key: "energy_company_id",
      label: "Energy Company ",
      value: filters.energy_company_id,
      options: dropdownOptions.energy_company_name,

      type: "select",
    },
    {
      key: "zone_id",
      label: "Zone",
      value: filters.zone_id,
      options: dropdownOptions.zone,
      type: "select",
    },
    {
      key: "regional_office_id",
      label: "Regional Office",
      value: filters.regional_office_id,
      options: dropdownOptions.ro_name,
      onChange: (value) => {
        handleFilterChange("regional_office_id", value);
      },
      type: "select",
    },

    {
      key: "sales_area_id",
      label: "Sales Area",
      value: filters.sales_area_id,
      options: dropdownOptions.sales_area_id,
      type: "select",
    },
    {
      key: "district_id",
      label: "District",
      value: filters.district_id,
      options: dropdownOptions.district,
      type: "select",
    },

    {
      key: "outlet_name",
      label: "Outlet ",
      value: filters.outlet_name,
      options: dropdownOptions.outlet_name,
      type: "select",
    },
    {
      key: "outlet_id",
      label: "Outlet Id",
      value: filters.outlet_id,
      options: dropdownOptions.outlet_id,
      type: "select",
    },
    {
      key: "customer_code",
      value: filters.customer_code,
      label: "Customer Code",
      options: dropdownOptions.customer_code,
      type: "select",
    },

    {
      key: "category",
      label: "Category",
      value: filters.category,
      options: dropdownOptions.category,
      type: "select",
    },
    {
      key: "location",
      label: "Location",
      value: filters.location,
      options: dropdownOptions.location,
      type: "select",
    },
    {
      key: "fromDate",
      label: "From Date",

      type: "date",
    },
    {
      key: "toDate",
      label: "To Date",
      type: "date",
    },
  ];
  const handleFilterChange = async (key, value) => {
    const updatedFilters = {
      ...filters,
      [key]: value,
    };
    // A cascading filter is "cleared" when its value is empty. On clear we must
    // NOT call the dependent fetch with an empty id — those backend endpoints
    // require a valid id and otherwise return an error toast
    // ("Sales Area Not Found", etc.). Instead just reset the dependent
    // dropdown option lists.
    const isCleared =
      value === "" ||
      value === null ||
      value === undefined ||
      (Array.isArray(value) && value.length === 0);

    if (key === "energy_company_id") {
      updatedFilters.zone_id = [];
      updatedFilters.ro_id = [];
      updatedFilters.sales_area_id = [];
      updatedFilters.district_id = [];
      updatedFilters.outlet_id = [];
      if (!isCleared) {
        fetchAllZone(value);
      } else {
        setDropdownOptions((prev) => ({
          ...prev,
          zone: [],
          ro_name: [],
          sales_area_id: [],
          district: [],
        }));
      }
    }
    else if (key === "zone_id") {
      updatedFilters.ro_id = [];
      updatedFilters.sales_area_id = [];
      updatedFilters.district_id = [];
      updatedFilters.outlet_id = [];
      if (!isCleared) {
        fetchAllRO(value);
      } else {
        setDropdownOptions((prev) => ({
          ...prev,
          ro_name: [],
          sales_area_id: [],
          district: [],
        }));
      }
    }
    else if (key === "regional_office_id") {
      updatedFilters.sales_area_id = [];
      updatedFilters.district_id = [];
      updatedFilters.outlet_id = [];
      if (!isCleared) {
        fetchAllSalesAreaAndOrderBy(value);
      } else {
        setDropdownOptions((prev) => ({
          ...prev,
          sales_area_id: [],
          district: [],
        }));
      }
    }
    else if (key === "sales_area_id") {
      updatedFilters.district_id = [];
      updatedFilters.outlet_id = [];
      if (!isCleared) {
        fetchAllDistrict(value);
      } else {
        setDropdownOptions((prev) => ({
          ...prev,
          district: [],
        }));
      }
    }
    else if (key === "district_id") {
      updatedFilters.outlet_id = [];
      if (!isCleared) {
        fetchAllOutletByDistrictId(value);
      }
    }

   
      setFilters(updatedFilters);
    await fetchOutletAllData({ ...updatedFilters });
    
   
  };

  // ── Excel & PDF report download ─────────────────────────────────────────
  // Forwards the SAME filters the Approved table is using so the file matches
  // the screen exactly. No date filter => backend defaults to current month.
  // Mandatory: Energy Company + Zone + Regional Office must be selected.
  // Purely additive — does not touch fetchOutletAllData/getAllOutlet/filters.
  const [isExcelLoading, setIsExcelLoading] = useState(false);
  const [isPdfLoading, setIsPdfLoading] = useState(false);

  const _unwrapFilterValue = (v) =>
    v && typeof v === "object" && "value" in v ? v.value : v;

  const buildReportPayload = () => {
    const flat = {};
    Object.entries(filters || {}).forEach(([key, val]) => {
      flat[key] = _unwrapFilterValue(val);
    });
    return { search, ...flat, status: 2 };
  };

  const _hasValue = (v) =>
    v !== undefined &&
    v !== null &&
    v !== "" &&
    !(Array.isArray(v) && v.length === 0);

  const validateMandatoryFilters = () => {
    const payload = buildReportPayload();
    const missing = [];
    if (!_hasValue(payload.energy_company_id)) missing.push("Energy Company");
    if (!_hasValue(payload.zone_id)) missing.push("Zone");
    if (!_hasValue(payload.regional_office_id)) missing.push("Regional Office");
    if (missing.length) {
      toast.error(
        `Please select ${missing.join(", ")} before downloading the report`
      );
      return false;
    }
    return true;
  };

  const triggerBrowserDownload = (axiosResponse, fallbackName) => {
    const cd = axiosResponse?.headers?.["content-disposition"] || "";
    const match = cd.match(/filename="?([^";\n]+)"?/);
    // Download names use hyphens, never underscores — same rule the backend applies.
    const filename = (match ? match[1] : fallbackName).replace(/[_\s]+/g, "-");
    const url = window.URL.createObjectURL(new Blob([axiosResponse.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  const handleDownloadExcel = async () => {
    if (isExcelLoading) return;
    if (!validateMandatoryFilters()) return;
    setIsExcelLoading(true);
    try {
      const res = await downloadApprovedFuelStationExcel(buildReportPayload());
      if (res?.data) {
        triggerBrowserDownload(res, "Approved_Fuel_Station_Outlets.xlsx");
      } else {
        toast.error(res?.message || "Failed to download Excel report");
      }
    } catch (e) {
      toast.error("Failed to download Excel report");
    } finally {
      setIsExcelLoading(false);
    }
  };

  const handleDownloadPdf = async () => {
    if (isPdfLoading) return;
    if (!validateMandatoryFilters()) return;
    setIsPdfLoading(true);
    try {
      const res = await downloadApprovedFuelStationPdf(buildReportPayload());
      if (res?.data) {
        triggerBrowserDownload(res, "Approved_Fuel_Station_Outlets.pdf");
      } else {
        toast.error(res?.message || "Failed to download PDF report");
      }
    } catch (e) {
      toast.error("Failed to download PDF report");
    } finally {
      setIsPdfLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Outlet Management · CMS Electricals</title>
      </Helmet>
      <Col md={12} data-aos={"fade-up"} data-aos-delay={200}>
        <DynamicFilter fields={fields} onChange={handleFilterChange} />
        <CustomTable
          id={"approved_outlet"}
          userPermission={checkPermission}
          isLoading={isLoading}
          rows={rows || []}
          columns={columns}
          pagination={{
            pageNo,
            pageSize,
            totalData,
          }}
          customHeaderComponent={() => (
            <TableHeader
              userPermission={checkPermission}
              setSearchText={setSearch}
              button={{ show: false }}
              extraComponent={
                <div className="d-flex align-items-center gap-2 ms-2">
                  <span
                    role="button"
                    title="Download Excel"
                    onClick={handleDownloadExcel}
                    className="cursor-pointer"
                    style={{
                      cursor: isExcelLoading ? "not-allowed" : "pointer",
                      opacity: isExcelLoading ? 0.6 : 1,
                    }}
                  >
                    {isExcelLoading ? (
                      <Spinner animation="grow" size="sm" variant="success" />
                    ) : (
                      <BsFileEarmarkExcelFill size={26} color="#16a34a" />
                    )}
                  </span>
                  <span
                    role="button"
                    title="Download PDF"
                    onClick={handleDownloadPdf}
                    className="cursor-pointer"
                    style={{
                      cursor: isPdfLoading ? "not-allowed" : "pointer",
                      opacity: isPdfLoading ? 0.6 : 1,
                    }}
                  >
                    {isPdfLoading ? (
                      <Spinner animation="grow" size="sm" variant="danger" />
                    ) : (
                      <BsFileEarmarkPdfFill size={26} color="#dc3545" />
                    )}
                  </span>
                </div>
              }
            />
          )}
          tableTitleComponent={
            <div>
              <UserPlus /> <strong>approved outlet</strong>
            </div>
          }
        />
        <ConfirmAlert
          size={"sm"}
          deleteFunction={handleDelete}
          hide={setShowDelete}
          show={showDelete}
          title={"Confirm Delete"}
          description={"Are you sure you want to delete this!!"}
        />

        <ConfirmAlert
          size={"sm"}
          deleteFunction={handleApproveReject}
          hide={setShowReject}
          show={showReject}
          title={"Confirm reject"}
          description={"Are you sure you want to reject this!!"}
        />
      </Col>
    </>
  );
};

export default ApprovedOutlet;
